import { COMMON_DATE_FORMAT } from 'constants/date';
import { FieldInputType } from 'constants/fields';
import { FieldType } from 'constants/formGenerator';
import { closingDocumentTypeOptions } from 'constants/options';

export const DOCUMENT_RECORD_FORM_CONFIG = {
  groups: [
    {
      type: FieldType.GROUP,
      key: 'document-record',
      fields: [
        {
          fieldId: 'documentType',
          type: FieldType.SELECT,
          nameInModel: 'documentType',
          inputProps: {
            label: 'Document Type',
            variant: 'outlined',
            required: true,
            options: closingDocumentTypeOptions,
            disableClearable: true,
            widthInColumns: 6,
          },
        },
        {
          fieldId: 'receivedDate',
          type: FieldType.DATE,
          nameInModel: 'receivedDate',
          inputProps: {
            label: 'Received Date',
            variant: 'outlined',
            format: COMMON_DATE_FORMAT,
            required: true,
            widthInColumns: 6,
          },
        },
        {
          fieldId: 'toInvestorDate',
          type: FieldType.DATE,
          nameInModel: 'toInvestorDate',
          noValidate: true,
          inputProps: {
            label: 'To Investor Date',
            variant: 'outlined',
            format: COMMON_DATE_FORMAT,
            required: false,
            widthInColumns: 6,
          },
        },
        {
          fieldId: 'documentRecordingAmount',
          type: FieldType.INPUT,
          nameInModel: 'documentRecordingAmount',
          noValidate: true,
          inputProps: {
            type: FieldInputType.CURRENCY,
            label: 'Recording Amount On Document',
            variant: 'outlined',
            required: false,
            widthInColumns: 6,
          },
        },
        {
          fieldId: 'finalCdRecordingAmount',
          type: FieldType.INPUT,
          nameInModel: 'finalCdRecordingAmount',
          noValidate: true,
          inputProps: {
            type: FieldInputType.CURRENCY,
            label: 'Recording Amount From Final CD',
            variant: 'outlined',
            required: false,
            widthInColumns: 6,
          },
        },
        {
          fieldId: 'comments',
          type: FieldType.INPUT,
          nameInModel: 'comments',
          noValidate: true,
          inputProps: {
            type: FieldInputType.TEXT,
            label: 'Comments',
            variant: 'outlined',
            required: false,
            widthInColumns: 6,
          },
        },
      ],
    },
  ],
};
